<template>
  <vue-google-autocomplete
    ref="address"
    :id="map"
    classname="form-control form-control-lg form-control-alt"
    placeholder="Please type your address"
    v-on:placechanged="getAddressData"
  >
  </vue-google-autocomplete>
</template>
<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete';
export default {
  name: 'AutoComplete',
  components: { VueGoogleAutocomplete},
  props: {
    map: {type: '', required: true},
    indexValue: {type: '', required: true}
  },
  data : () => ({
    address: ''
  }),
  methods: {
    getAddressData: function (addressData, formatted_address, id) {
      this.address = addressData;
      let arrAddressData  = [];
      arrAddressData['index'] = this.indexValue;
      arrAddressData['addressValue'] = this.address;
      this.$emit('autofill-address', arrAddressData);
    }
  }
};
</script>



// WEBPACK FOOTER //
// source/components/google-input/GoogleAutoSearch.vue